import type { SVGProps } from "react";
export interface ChatOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ChatOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ChatOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M7.937 1.641C11.927.08 16.64.906 19.867 4.133c3.226 3.226 4.054 7.94 2.491 11.93a1.125 1.125 0 1 1-2.094-.82A8.879 8.879 0 0 0 8.758 3.736a1.125 1.125 0 0 1-.82-2.096Zm-6.732-.436a1.125 1.125 0 0 1 1.505-.078l.085.078 20 20 .077.086a1.124 1.124 0 0 1-1.581 1.582l-.087-.078-2.175-2.175a11.13 11.13 0 0 1-12.01 1.331l-3.169.762c-1.543.37-2.934-1.02-2.563-2.562l.76-3.173A11.13 11.13 0 0 1 3.378 4.971L1.205 2.795l-.078-.084a1.125 1.125 0 0 1 .078-1.506M4.978 6.57a8.89 8.89 0 0 0-.752 9.717c.136.245.174.534.109.807l-.813 3.382 3.385-.811.207-.03c.207-.01.415.038.599.14a8.88 8.88 0 0 0 9.716-.755z"
      />
    </svg>
  );
}
